import { TableCellWithAdditionalCountProps } from 'components/shared'
import { AgreementDTO } from 'models'

export const getStoresCellProps = (
  agreement: AgreementDTO
): TableCellWithAdditionalCountProps => {
  const brandNamesSet = new Set<string>()
  agreement.scopes.forEach(scope => {
    scope.filters.forEach(filter => {
      filter.brands.forEach(brand => brandNamesSet.add(brand.name))
    })
  })
  return {
    text: brandNamesSet.values().next().value,
    totalCount: brandNamesSet.size
  }
}

export const getProjectsCellProps = (
  agreement: AgreementDTO
): TableCellWithAdditionalCountProps => {
  const projectNamesSet = new Set<string>()
  agreement.scopes.forEach(scope => {
    scope.filters.forEach(filter => {
      filter.projects.forEach(project => projectNamesSet.add(project.name))
    })
  })
  return {
    text: projectNamesSet.values().next().value,
    totalCount: projectNamesSet.size
  }
}

export const getProductsCount = (
  agreement: AgreementDTO
): number => {
  const productIds = new Set<number>()
  agreement.scopes.forEach(scope => {
    scope.filters.forEach(filter => {
      filter.products.forEach(p => productIds.add(p.id))
    })
  })
  return productIds.size
}
